import SpriteSymbol from "../../../hac-ng/node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../hac-ng/node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "map-pin",
  "use": "map-pin-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol fill=\"currentColor\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"map-pin\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M7.28 14.86a19.805 19.805 0 01-2.577-2.413C3.026 10.56 2 8.937 2 7a6 6 0 1112 0c0 1.937-1.026 3.56-2.703 5.447A19.805 19.805 0 018.72 14.86a1.2 1.2 0 01-1.44 0zM8 14s5-3.39 5-7.08C13 4.203 10.761 2 8 2S3 4.203 3 6.92C3 10.61 8 14 8 14zm1-8a1 1 0 11-2 0 1 1 0 012 0z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol